<template>
  <BaseModalConfirm
    ref="BaseModalConfirmRef"
    :svg="{ name: 'common/warning', style: { color: 'var(--warning-500)' } }"
    :title="$tc('regAuthForgot.regBonus.modal.noBonus.title')"
    :text="$tc('regAuthForgot.regBonus.modal.noBonus.text')"
    @submit="$emit('no-bonus')"
  >
    <template #controls="{ onSubmit, onCancel}">
      <UiBtn
        :text="$tc('regAuthForgot.regBonus.modal.noBonus.cancel')"
        color="primary"
        @click="onCancel"
      />
      <UiBtn
        :text="$tc('regAuthForgot.regBonus.modal.noBonus.confirm')"
        @click="onSubmit"
      />
    </template>
  </BaseModalConfirm>
</template>

<script>
import BaseModalConfirm from '@/components/Base/Modal/Confirm'

export default {
  name: 'RegistrationBonusModalNoBonusWarn',
  components: { BaseModalConfirm },
  methods: {
    async $asyncOpen() {
      return await this.$refs.BaseModalConfirmRef.$asyncOpen()
    },
  },
}
</script>
